import clsx from 'clsx'
import React, {FC} from 'react'
import {Link} from 'react-router-dom'
import {usePageData, useLayout} from '../../../core'

const DefaultTitle: FC = () => {
    const {pageTitle, pageBreadcrumbs} = usePageData()
    const {config, attributes, classes} = useLayout()

    return (
        <div {...attributes.pageTitle}
             className={clsx('page-title d-flex', classes.pageTitle.join(' '))}
        >
            {pageBreadcrumbs &&
                pageBreadcrumbs.length > 0 &&
                config.pageTitle &&
                config.pageTitle.breadCrumbs && (
                    <>
                        {config.pageTitle.direction === 'row' && (
                            <span className="h-20px border-gray-200 border-start mx-4"></span>
                        )}
                        <ul className="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
                            {Array.from(pageBreadcrumbs).map((item, index) => (
                                <li
                                    className={clsx('breadcrumb-item', {
                                        'text-dark': !item.isSeparator && item.isActive,
                                        'text-muted': !item.isSeparator && !item.isActive,
                                    })}
                                    key={`${item.path}${index}`}
                                >
                                    {!item.isSeparator ? (
                                        <Link className="text-muted text-hover-primary" to={item.path}>
                                            {item.title}
                                        </Link>
                                    ) : (
                                        <span className="bullet bg-gray-200 w-5px h-2px"></span>
                                    )}
                                </li>
                            ))}
                            <li className="breadcrumb-item text-dark">{pageTitle}</li>
                        </ul>
                    </>
                )}
        </div>
    )
}

export {DefaultTitle}
